export enum FilterExpression {
    equals = 'equals',
    greaterThan = 'greaterThan',
    lessThan = 'lessThan',
    notEquals = 'notEquals',
    specified = 'specified',
    in = 'in',
    none = ''
}
